(() => {
  const roots = document.querySelectorAll('[data-chr-txa]');

  const placeMidSignup = (article) => {
    const signup = article.querySelector('[data-txa-mid-signup]');
    if (!signup || signup.dataset.txaPlaced === 'true') return;

    /* Optional future manual anchor. If present in article HTML, it wins. */
    const explicitAnchor = article.querySelector('[data-transmission-signup-anchor]');
    if (explicitAnchor) {
      explicitAnchor.insertAdjacentElement('afterend', signup);
      signup.dataset.txaPlaced = 'true';
      return;
    }

    /*
      Default editorial rule:
      1) Prefer the featured/object figure (TR001 caption: OBJECT FRAME / ...).
      2) Place the signup after the first interpretive paragraph following that figure.
      3) If no figure exists, place it before the midpoint H2.
      This keeps the module editorially integrated instead of behaving like an ad block.
    */
    const figures = [...article.querySelectorAll('figure')].filter((figure) => !figure.closest('[data-txa-mid-signup]'));
    const objectFigure = figures.find((figure) => {
      const caption = figure.querySelector('figcaption');
      const text = caption ? caption.textContent : figure.textContent;
      return /OBJECT FRAME|FEATURED OBJECT|CITY SERIES/i.test(text || '');
    }) || figures[0];

    if (objectFigure) {
      let cursor = objectFigure.nextElementSibling;
      let interpretiveParagraph = null;

      while (cursor && !/^H[23]$/.test(cursor.tagName)) {
        if (cursor.tagName === 'P') {
          interpretiveParagraph = cursor;
          break;
        }
        cursor = cursor.nextElementSibling;
      }

      (interpretiveParagraph || objectFigure).insertAdjacentElement('afterend', signup);
      signup.dataset.txaPlaced = 'true';
      return;
    }

    const headings = [...article.querySelectorAll('h2')].filter(heading => !heading.closest('[data-fg-bridge-slot]'));
    if (headings.length) {
      const index = Math.min(headings.length - 1, Math.max(1, Math.floor(headings.length / 2)));
      headings[index].insertAdjacentElement('beforebegin', signup);
    }

    signup.dataset.txaPlaced = 'true';
  };

  roots.forEach((root) => {
    const article = root.querySelector('[data-txa-article-body]');
    if (!article) return;

    placeMidSignup(article);

    const toc = root.querySelector('[data-txa-toc]');
    const tocWrap = root.querySelector('[data-txa-toc-wrap]');
    if (!toc) return;

    const headings = [...article.querySelectorAll('h2')].filter(heading => !heading.closest('[data-fg-bridge-slot]'));
    if (!headings.length) {
      if (tocWrap) tocWrap.hidden = true;
      return;
    }

    const links = [];
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `tx-section-${String(index + 1).padStart(2, '0')}`;

      const item = document.createElement('li');
      const link = document.createElement('a');
      const number = document.createElement('b');
      const label = document.createElement('span');

      number.textContent = String(index + 1).padStart(2, '0');
      label.textContent = heading.textContent.trim();
      link.href = `#${heading.id}`;
      link.append(number, label);
      item.append(link);
      toc.append(item);
      links.push(link);
    });

    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        links.forEach((link) => link.classList.toggle('is-active', link.hash === `#${entry.target.id}`));
      });
    }, { rootMargin: '-25% 0px -65% 0px', threshold: 0 });

    headings.forEach((heading) => observer.observe(heading));
  });
})();
